import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Soportes", href: "#soportes" },
  { label: "Beneficios", href: "#beneficios" },
  { label: "Sobre Nosotros", href: "#sobre" },
  { label: "Contacto", href: "#contacto" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50"
      style={{
        backgroundColor: scrolled ? "rgba(5,5,5,0.92)" : "transparent",
        backdropFilter: scrolled ? "blur(16px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.05)" : "none",
        transition: "background-color 0.5s, backdrop-filter 0.5s, border-color 0.5s",
      }}
    >
      <div className="edi-container h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="/" data-testid="navbar-logo" className="flex items-baseline gap-0">
          <span
            className="font-heading font-bold text-2xl tracking-widest uppercase text-white"
            style={{ letterSpacing: "0.12em" }}
          >
            EDIMEDIA
          </span>
          <span
            className="font-heading font-bold text-2xl tracking-widest uppercase"
            style={{ color: "#00E0FF", letterSpacing: "0.12em" }}
          >
            .CL
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-zinc-400 hover:text-white text-xs font-bold uppercase"
              style={{ letterSpacing: "0.15em", transition: "color 0.3s" }}
            >
              {link.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <a
          href="#contacto"
          data-testid="navbar-cta"
          className="hidden lg:block font-bold uppercase text-xs text-black"
          style={{
            backgroundColor: "#00E0FF",
            padding: "12px 28px",
            letterSpacing: "0.15em",
            transition: "background-color 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#ffffff")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#00E0FF")}
        >
          Contactar
        </a>

        {/* Mobile menu button */}
        <button
          data-testid="mobile-menu-btn"
          className="lg:hidden text-white p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden overflow-hidden"
            style={{
              backgroundColor: "rgba(5,5,5,0.97)",
              backdropFilter: "blur(20px)",
              borderTop: "1px solid rgba(255,255,255,0.05)",
            }}
          >
            <div className="edi-container py-8 flex flex-col gap-6">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  data-testid={`mobile-link-${link.label}`}
                  className="text-zinc-400 hover:text-white text-sm font-bold uppercase"
                  style={{ letterSpacing: "0.15em", transition: "color 0.3s" }}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="#contacto"
                onClick={() => setMenuOpen(false)}
                className="inline-block text-center font-bold uppercase text-xs text-black"
                style={{
                  backgroundColor: "#00E0FF",
                  padding: "14px 28px",
                  letterSpacing: "0.15em",
                }}
              >
                Contactar
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export { Navbar };
